var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNote1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.825 3.21C13.867 2.571 13.381 1.91 13.381 1.25C13.381 0.559644 12.8214 0 12.131 0C11.4407 0 10.881 0.559644 10.881 1.25V15.75C10.881 15.8881 10.7691 16 10.631 16H9.38101C7.17187 16 5.38101 17.7909 5.38101 20C5.38101 22.2091 7.17187 24 9.38101 24C11.5679 23.9473 13.3283 22.1869 13.381 20V5.728C13.381 5.63331 13.4345 5.54674 13.5192 5.50439C13.6039 5.46205 13.7053 5.47118 13.781 5.528C17.2 8.003 16.215 10.561 15.081 13.509L14.968 13.809C14.78 14.2316 14.8408 14.7235 15.126 15.0877C15.4112 15.4519 15.8742 15.6288 16.3296 15.5476C16.785 15.4664 17.1583 15.1403 17.3 14.7L17.413 14.407C18.566 11.4 20.312 6.868 14.825 3.21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote1);
export default __webpack_public_path__ + "static/media/musicNote1.f999b22f.svg";
export { ForwardRef as ReactComponent };